<template>
  <div>
    <a-modal
      :visible="addMemberVisible"
      :title="addMemberTitle"
      on-ok="handleOk"
      :destroy-on-close="true"
      width="920px"
      class="add-memeber-dialog"
      :mask-closable="false"
      @cancel="handleCancel"
    >
      <template slot="footer">
        <a-button
          key="back"
          @click="handleCancel"
        >
          {{ $t('message["896"]') }}
        </a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="addMemberLoading"
          @click="handleOk"
        >
          {{ $t('message["915"]') }}
        </a-button>
      </template>
      <div>
        <div class="main-member-parent">
          <template>
            <div
              v-if="dingtalkStructureStatus"
              class="main-member-children"
            >
              <div class="search-div">
                <a-input-search
                  v-model="searchVal"
                  :placeholder="truenamePlaceholder"
                  @keyup="onSearch"
                />
              </div>
              <template v-if="addMemberListLocal.length">
                <div class="add-search-result">
                  <ul
                    class="scroll_bar_beautify_ff origin-list-ul"
                  >
                    <li
                      v-for="(item) in addMemberListLocal"
                      :key="item.key"
                    >
                      <div class="p-item-tit">
                        <h2>
                          <span>{{ item.truename }}</span>
                          <span class="tag-list-content">
                            <a-tag
                              v-for="(subItem,subIndex) in item.roleinfo"
                              :key="subIndex"
                              class="tag"
                            >{{ subItem.rolename }}</a-tag>
                          </span>
                          <a-checkbox
                            v-if="item.checkboxtype===3"
                            :checked="true"
                            :disabled="true"
                            class="checkbox"
                            @change="onChange(item)"
                          />
                          <a-checkbox
                            v-else-if="item.checkboxtype===2"
                            :disabled="true"
                            class="checkbox"
                            @change="onChange(item)"
                          />
                          <a-checkbox
                            v-else-if="item.checkboxtype===1&&item.checkboxtypeLabel===0"
                            :checked="false"
                            class="checkbox"
                            @change="onChange(item)"
                          />
                          <a-checkbox
                            v-else-if="item.checkboxtype===1&&item.checkboxtypeLabel===1"
                            :checked="true"
                            class="checkbox"
                            @change="onChange(item)"
                          />
                          <a-checkbox
                            v-else
                            class="checkbox"
                            @change="onChange(item)"
                          />
                        </h2>
                        <p
                          v-if="item.label"
                          class="part-team-name"
                        >
                          {{ item.label ? `[${item.label}]`: '' }}
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </template>
              <div
                v-else-if="noresult && !addMemberListLocal.length"
                class="search-no-result"
              >
                {{ $t('message["1553"]') }}
              </div>
              <div
                v-else-if="!noresult && !addMemberListLocal.length"
                class=""
              >
                <div class="tree-list-box">
                  <div class="scroll_bar_beautify_ff tree-list">
                    <a-tree
                      v-if="structureList.length"
                      :default-expanded-keys="[]"
                      :tree-data="structureList"
                      :selectable="false"
                    >
                      <template
                        slot="key"
                        slot-scope="{title}"
                      >
                        <div
                          class="uncheck-item"
                          :class="{'checkbox-box-c': title.sys_userid}"
                        >
                          <span> {{ title.truename }}</span>
                          <template v-if="title.sys_userid">
                            <span class="tag-list-content">
                              <a-tag
                                v-for="(subItem,subIndex) in title.roleinfo"
                                :key="subIndex"
                                class="tag"
                              >{{ subItem.rolename }}</a-tag>
                            </span>
                            <a-checkbox
                              v-if="title.checkboxtype===3"
                              :checked="true"
                              :disabled="true"
                              class="checkbox"
                              @change="onChange(title)"
                            />
                            <a-checkbox
                              v-else-if="title.checkboxtype===2"
                              :disabled="true"
                              class="checkbox"
                              @change="onChange(title)"
                            />
                            <a-checkbox
                              v-else-if="title.checkboxtype===1&&title.checkboxtypeLabel===0"
                              :checked="false"
                              class="checkbox"
                              @change="onChange(title)"
                            />
                            <a-checkbox
                              v-else-if="title.checkboxtype===1&&title.checkboxtypeLabel===1"
                              :checked="true"
                              class="checkbox"
                              @change="onChange(title)"
                            />
                            <a-checkbox
                              v-else
                              class="checkbox"
                              @change="onChange(title)"
                            />
                          </template>
                        </div>
                      </template>
                    </a-tree>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else
              class="main-member-children"
            >
              <div class="search-div">
                <a-input-search
                  v-model="searchVal"
                  :placeholder="truenamePlaceholder"
                  @keyup="onSearch"
                />
              </div>
              <div class="select-normal-box">
                <div class="select-list-div scroll_bar_beautify_ff">
                  <a-list
                    class="remain-member-list"
                    :data-source="addMemberListLocal"
                  >
                    <a-list-item
                      slot="renderItem"
                      slot-scope="item"
                      class="a-list-item"
                    >
                      <span class="list-content-span">
                        <a-checkbox
                          v-if="item.checkboxtype===3"
                          :checked="true"
                          :disabled="true"
                          class="checkbox"
                          @change="onChange(item)"
                        />
                        <a-checkbox
                          v-else-if="item.checkboxtype===2"
                          :disabled="true"
                          class="checkbox"
                          @change="onChange(item)"
                        />
                        <a-checkbox
                          v-else-if="item.checkboxtype===1&&item.checkboxtypeLabel===0"
                          :checked="false"
                          class="checkbox"
                          @change="onChange(item)"
                        />
                        <a-checkbox
                          v-else-if="item.checkboxtype===1&&item.checkboxtypeLabel===1"
                          :checked="true"
                          class="checkbox"
                          @change="onChange(item)"
                        />
                        <a-checkbox
                          v-else
                          class="checkbox"
                          @change="onChange(item)"
                        />
                        <!-- <span class="text"> {{ item.truename }}</span> -->
                        <span class="text">
                          <other-tooltip
                            col-key="truename"
                            :text="item.truename || '--'"
                          />
                        </span>
                        <span class="tag-list-content">
                          <a-tag
                            v-for="(subItem,subIndex) in item.roleinfo"
                            :key="subIndex"
                            class="tag"
                          >{{ subItem.rolename }}</a-tag>
                        </span>
                      </span>
                    </a-list-item>
                  </a-list>
                </div>
              </div>
            </div>
          </template>
          <div class="main-member-children">
            <div class="select-title-div">
              {{ $t('message["1477"]') }}
            </div>
            <a-list>
              <a-list-item
                v-for="(items,indexs) in selectedMembers"
                :key="indexs"
              >
                <span class="select-name-span">{{ items.truename }}</span>
                <a-select
                  show-search
                  :placeholder="selectPlaceholder"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  class="selected-select"
                  :default-value="items.roleValueArray"
                  :disabled="items.roleValueArray.length>0?true:false"
                  @change="handleChange($event,items)"
                >
                  <a-select-option
                    v-for="(roleItem,roleIndex) in roleListLocal"
                    :key="roleIndex"
                    :value="roleItem.roleid"
                  >
                    {{ roleItem.rolename }}
                  </a-select-option>
                </a-select>
                <span v-if="!items.noGroup">
                  <a-select
                    v-if="items.isGroup"
                    mode="multiple"
                    :allow-clear="true"
                    :value="items.groupValueArray"
                    class="second-seclect"
                    :placeholder="selectGroupPlace"
                    @change="handleChangeSelectGroup($event,items)"
                  >
                    <a-select-opt-group
                      v-for="(itemgroup) in items.groupLocal"
                      :key="itemgroup.roleid"
                      :label="itemgroup.teamname"
                    >
                      <a-select-option
                        v-for="(itemoptgroup) in itemgroup.groups"
                        :key="itemoptgroup.groupid"
                        :value="itemoptgroup.groupid"
                      >{{ itemoptgroup.groupname }}</a-select-option>
                    </a-select-opt-group>
                  </a-select>
                  <a-select
                    v-else
                    mode="multiple"
                    class="second-seclect"
                    :allow-clear="true"
                    :placeholder="selectGroupPlace"
                    :value="items.groupValueArray"
                    :disabled="isDefaultGroup"
                    @change="handleChangegroup($event,items)"
                  >
                    <a-select-option
                      v-for="(groupItem,groupIndex) in items.groupLocal"
                      :key="groupIndex"
                      :value="groupItem.groupid"
                    > {{ groupItem.groupname }}
                    </a-select-option>
                  </a-select>
                </span>
                <i
                  class="iconfont iconicon-test5 remove-icon"
                  @click="removeSelectedUsers(items)"
                />
              </a-list-item>
            </a-list>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'
import OtherTooltip from './OtherTooltip'
export default {
  components: {
    OtherTooltip
  },
  props: {
    dialogData: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      visible: false,
      roleValueArray: [],
      addMemberTitle: '',
      selectedMembers: [],
      roleListLocal: [],
      isDefaultGroup: false,
      groupLocal: [],
      groupValueArray: [],
      addMemberListLocal: [],
      addMemberListLocalCash: [],
      noresult: false,
      searchVal: '',
      cloneRoleIdArray: [],
      cloneGroupIdArray: []
    }
  },
  computed: {
    ...mapState('team/manage', ['teamItemName', 'treeDefaultKey', 'selectTreenDataKey', 'selectTreenDataId']),
    ...mapState('team/member', ['addMemberList', 'userLimitInfo', 'addMemberVisible', 'addMemberLoading', 'roleList', 'groupList', 'addStructureList']),
    ...mapGetters('team/member', ['structureList']),
    dingtalkStructureStatus () {
      return this.$store.state.baseinfo.dingtalk_structure_status
    },
    upgradeTip () {
      return this.$t('message["168"]').split('|')
    },
    upgradeTip2 () {
      return this.$t('message["175"]').split('|')
    },
    selectGroupPlace () {
      return this.$t('message["885"]')
    },
    selectPlaceholder () {
      return this.$t('message["855"]')
    },
    truenamePlaceholder () {
      return this.$t('message["1126"]')
    }
  },
  watch: {
    teamItemName (val) {
      if (!val) return
      this.addMemberTitle = `${this.teamItemName}-${this.$t('message["1191"]')}`
    },
    userLimitInfo (val) {
      if (!val) return
      let text = ''
      let confirmText = ''
      if (val.isvip === 0) {
        confirmText = this.$t('message["1050"]')
        text = `${this.upgradeTip[0]}${val.user_limit}${this.upgradeTip[1]}`
      } else if (val.isvip === 1) {
        text = `${this.upgradeTip2[0]}${val.user_limit}${this.upgradeTip2[1]}`
        confirmText = this.$t('message["579"]')
      }
      const that = this
      this.$confirm({
        title: <div>{this.$t('message["1323"]')}</div>,
        closable: false,
        centered: true,
        content: text,
        iconType: 'exclamation-circle',
        okText: confirmText,
        cancelText: this.$t('message["896"]'),
        onOk () {
          that.setAddMemberVisible(false)
          if (confirmText === that.$t('message["1050"]')) {
            that.$router.push({
              name: 'ServiceIndex'
            })
          } else if (confirmText === that.$t('message["579"]')) {
            that.$router.push({
              name: 'ServiceSuper'
            })
          }
        },
        onCancel () {
          that.setAddMemberVisible(false)
        }
      })
    },
    addMemberVisible (val) {
      if (!val) return
      this.visible = val
    },
    roleList (val) {
      if (!val) return
      if (Array.isArray(val)) {
        val.map(value => {
          value.roleid = value.roleid.toString()
        })
      }
      this.roleListLocal = val
    },
    addMemberList (val) {
      if (!val) return
      this.addMemberListLocal = this.addCheckboxtypeLabelForMember(val)
      this.addMemberListLocalCash = this.addCheckboxtypeLabelForMember(val)
    },
    groupList (val) {
      if (!val) return
      let tempv = cloneDeep(this.selectedMembers) // JSON.parse(JSON.stringify(this.selectedMembers))
      tempv.map(value => {
        val.map(values => {
          if (values.userid === value.userid) {
            if (Array.isArray(values.groupArray)) {
              values.groupArray.map(item => {
                item.groupid = item.groupid.toString()
                item.roleid = item.roleid.toString()
              })
              if (values.groupArray[0].teamid) {
                value.isGroup = true
              } else {
                value.isGroup = false
              }
              value.groupLocal = values.groupArray
            } else {
              value.isGroup = false
              value.groupLocal = []
            }
            value.groupid = value.groupValueArray
          }
        })
      })
      this.selectedMembers = tempv
    },
    selectTreenDataKey (val) {
      if (!val) return
      this.roleValueArray = []
      this.groupValueArray = []
      this.cloneRoleIdArray = []
      this.cloneRoleIdArray = []
      if (val.indexOf('|') >= 0) {
        this.isDefaultGroup = true
        const groupArrs = val.split('|')
        const [roleInfo, groupInfo] = groupArrs
        const roleArr = roleInfo.split('-')
        const groupArr = groupInfo.split('-')
        this.roleValueArray = [roleArr[1].toString()]
        this.cloneRoleIdArray = [roleArr[1].toString()]
        this.groupValueArray = [groupArr[1].toString()]
        this.cloneGroupIdArray = [groupArr[1].toString()]
      } else {
        const tempArr = val.split('-')
        const [name, id] = tempArr
        if (name === 'projectid') {
          this.isDefaultGroup = false
        } else if (name === 'roleid') {
          this.isDefaultGroup = false
          this.roleValueArray = [id]
          this.cloneRoleIdArray = [id]
        }
      }
    }
  },
  mounted () {
    this.addMemberTitle = this.teamItemName + '-' + this.$t('message["1191"]')
  },
  methods: {
    ...mapMutations('team/member', ['setAddMemberVisible', 'setAddMemberLoading']),
    ...mapActions('team/member', ['changAddMemberLoading', 'changAddMemberVisible', 'fetchAddmemberList', 'fetchGetRoles', 'fetchGetGroups', 'fetchSaveAddMember']),
    // 添加成员--选中取消操作
    onChange (val) {
      if (!val.groupLocal) {
        val.groupLocal = []
      }
      val.roleValueArray = []
      if (val.roleinfo.length > 0 && val.roleinfo[0].roleid && val.roleinfo[0].system_role * 1 === 1) {
        val.roleValueArray[0] = val.roleinfo[0].roleid + ''
        // val['system_role'] = val.roleinfo[0].system_role * 1
      } else {
        val.roleValueArray = this.cloneRoleIdArray
      }
      val.roleid = this.roleValueArray[0]
      // this.roleValueArray[0] = val.roleid
      let hasSelectedNum = -1
      this.selectedMembers.some((value, index) => {
        if (value.userid === val.userid) {
          hasSelectedNum = index
          return true
        }
      })
      if (hasSelectedNum >= 0) {
        this.selectedMembers = this.selectedMembers.slice(0, hasSelectedNum).concat(this.selectedMembers.slice(hasSelectedNum + 1))
      } else {
        this.selectedMembers.push(this.getMemberValue(val))
      }
      if (this.dingtalkStructureStatus) {
        this.itemCheckedLoop(this.structureList, val)
      } else {
        let remainArray = JSON.parse(JSON.stringify(this.addMemberListLocal))
        remainArray.map(valls => {
          if (valls.userid === val.userid) {
            valls.checkboxtype = 1
            if (valls.checkboxtypeLabel === 0) {
              valls.checkboxtypeLabel = 1
            } else if (valls.checkboxtypeLabel === 1) {
              valls.checkboxtypeLabel = 0
            }
          }
        })
        this.addMemberListLocal = remainArray
      }
      if (!this.selectTreenDataKey) return
      let type = ''
      const tempArr = this.selectTreenDataKey.split('-')
      const [name, id] = tempArr
      if (name === 'projectid') {
        type = 'project'
      } else if (name === 'roleid') {
        type = 'team'
        this.fetchGetGroups({ roleid: id, userid: val.userid, type, value: id })
      } else {
        type = 'group'
        const groupArrs = val.split('|')
        const [roleInfo, groupInfo] = groupArrs
        const roleArr = roleInfo.split('-')
        const groupArr = groupInfo.split('-')
        this.fetchGetGroups({ roleid: roleArr[1], userid: val.userid, type, value: groupArr[1] })
      }
    },
    addCheckboxtypeLabelForMember (array) {
      array.map(value => {
        value.checkboxtypeLabel = 0
      })
      return array
    },
    getMemberDeepLoop (arr, item) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].sys_userid && (item.userid === arr[i].sys_userid) && (item.key === arr[i].key)) {
          arr[i].noGroup = false
          // tempValue = arr[i]
          if (this.groupValueArray.length > 0) {
            arr[i].groupValueArray = this.groupValueArray
          } else {
            arr[i].groupValueArray = []
          }
          return arr[i]
        } else {
          if (arr[i].children && arr[i].children.length) {
            let result = this.getMemberDeepLoop(arr[i].children, item)
            if (result) {
              return result
            }
          }
        }
      }
    },
    itemCheckedLoop (arr, item) {
      arr.forEach(valls => {
        if (valls.userid === item.title.userid) {
          valls.checkboxtype = 1
          if (valls.checkboxtypeLabel === 0) {
            valls.checkboxtypeLabel = 1
          } else if (valls.checkboxtypeLabel === 1) {
            valls.checkboxtypeLabel = 0
          }
        } else {
          if (valls.children && valls.children.length) {
            this.itemCheckedLoop(valls.children, item)
          }
        }
      })
    },
    getMemberValue (item) {
      let tempValue = null
      if (this.dingtalkStructureStatus) {
        tempValue = this.getMemberDeepLoop(this.addStructureList, item, tempValue)
      } else {
        this.addMemberListLocal.some(value => {
          if (item.userid === value.userid) {
            value.noGroup = false
            tempValue = value
            if (this.groupValueArray.length > 0) {
              value.groupValueArray = this.groupValueArray
            } else {
              value.groupValueArray = []
            }
            return true
          }
        })
      }
      return tempValue
    },
    // 添加成员---昵称搜索操作
    onSearch (e) {
      const val = this.searchVal.trim() // e.target.value.trim()
      // console.log(val.target.value)
      let tempListDatas = []
      if (val) {
        if (this.dingtalkStructureStatus) {
          this.addMemberListLocal = []
          this.searchdeep(this.structureList, this.addMemberListLocal, val, null)
          this.selectedMembers.forEach(item => {
            this.addMemberListLocal.forEach(item2 => {
              if (item2.userid === item.userid) {
                item2.checkboxtypeLabel = 1
              } else {
                item2.checkboxtypeLabel = 0
              }
            })
          })
          if (this.addMemberListLocal.length) {
            this.noresult = false
          } else {
            this.noresult = true
          }
        }
        this.addMemberListLocal.map(values => {
          if (values.truename.indexOf(val) > -1) {
            tempListDatas.push(values)
          }
        })
      } else {
        if (this.dingtalkStructureStatus) {
          tempListDatas = []
          this.noresult = false
        } else {
          tempListDatas = this.addMemberListLocalCash
        }
      }
      this.addMemberListLocal = tempListDatas
    },
    removeSelectedUsers (item) {
      let tempArray = cloneDeep(this.selectedMembers) // JSON.parse(JSON.stringify(this.selectedMembers))
      tempArray.some((value, index) => {
        if (value.userid === item.userid) {
          tempArray = this.selectedMembers.slice(0, index).concat(this.selectedMembers.slice(index + 1))
          this.selectedMembers = tempArray
          return true
        }
      })
      if (this.dingtalkStructureStatus) {
        this.delDeepLoop(this.structureList, item)
      } else {
        let remainArray = JSON.parse(JSON.stringify(this.addMemberListLocal))
        remainArray.map(valls => {
          if (valls.userid === item.userid) {
            valls.checkboxtype = 1
            valls.checkboxtypeLabel = 0
          }
        })
        this.addMemberListLocal = remainArray
      }
    },
    // 树形结构删除
    delDeepLoop (arr, item) {
      arr.forEach(valls => {
        if (valls.userid === item.userid) {
          valls.checkboxtype = 1
          valls.checkboxtypeLabel = 0
        } else {
          if (valls.children && valls.children.length) {
            this.delDeepLoop(valls.children, item)
          }
        }
      })
    },
    // 待选成员数据初始化操作
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    renderItem (item) {
      const customLabel = (
        <span class="custom-item">
          {item.title} - {item.description}
        </span>
      )
      return {
        label: customLabel, // for displayed item
        value: item.title // for title and filter matching
      }
    },
    // 角色选择操作
    handleChange (roleid, item) {
      this.selectedMembers.some((values, indexs) => {
        if (item.userid === values.userid) {
          values.roleid = roleid
          values.noGroup = false
          values.groupValueArray = []
          this.roleListLocal.some(vvs => {
            if (vvs.roleid.toString() === roleid) {
              if (vvs.system_role === 2) {
                values.noGroup = true
                values.groupid = []
                this.$set(this.selectedMembers, indexs, values)
              }
              return true
            }
          })
          this.$set(this.selectedMembers, indexs, values)
          return true
        }
      })
      let strSelectKey = ''
      if (!this.selectTreenDataKey) {
        strSelectKey = this.treeDefaultKey[0]
      } else {
        strSelectKey = this.selectTreenDataKey
      }
      let type = ''
      const tempArr = strSelectKey.split('-')
      const [name, id] = tempArr
      if (name === 'projectid') {
        type = 'project'
        let isSend = false
        this.roleListLocal.some(vvs => {
          if (vvs.roleid.toString() === roleid) {
            if (vvs.system_role === 2) {
              isSend = true
            }
            return true
          }
        })
        if (isSend) {
          return
        }
        this.fetchGetGroups({ roleid, userid: item.userid, type, value: id })
      } else if (name === 'roleid') {
        type = 'team'
        let isSend = false
        this.roleListLocal.some(vvs => {
          if (vvs.roleid.toString() === roleid) {
            if (vvs.system_role === 2) {
              isSend = true
            }
            return true
          }
        })
        if (isSend) {
          return
        }
        this.fetchGetGroups({ roleid, userid: item.userid, type, value: roleid })
      } else {
        type = 'group'
        const groupArrs = this.selectTreenDataKey.split('|')
        const groupArr = groupArrs[1].split('-')
        this.fetchGetGroups({ roleid, userid: item.userid, type, value: groupArr[1] })
      }
    },
    handleChangeSelectGroup (val, item) {
      // item.groupValueArray = val
      this.$set(item, 'groupValueArray', val)
      this.selectedMembers.some(values => {
        if (item.userid === values.userid) {
          values.groupid = val
          this.$set(values, 'groupValueArray', val)
          // values.groupValueArray = val
          return true
        }
      })
    },
    // 小组选择操作
    handleChangegroup (val, item) {
      this.$set(item, 'groupValueArray', val)
      // item.groupValueArray = val
      this.selectedMembers.some(values => {
        if (item.userid === values.userid) {
          values.groupid = val
          this.$set(values, 'groupValueArray', val)
          // values.groupValueArray = val
          return true
        }
      })
    },
    // 添加成员--保存操作
    handleOk (e) {
      const viferfy = this.setenceWarning(this.selectedMembers)
      if (viferfy) {
        return
      }
      const memberinfo = this.getVoldMembers(cloneDeep(this.selectedMembers))
      if (memberinfo.length === 0) {
        this.$message.warning(this.$t('message["851"]'))
        return
      }
      this.setAddMemberLoading(true)
      this.fetchSaveAddMember(memberinfo)
      this.selectedMembers = []
    },
    setenceWarning (array) {
      let isnoGroup = false
      const grouptip = this.$t('message["850"]').split('|')
      array.some(value => {
        if (value.roleid) {
          this.roleListLocal.some(values => {
            if (values.roleid * 1 === value.roleid * 1) {
              if (values.system_role * 1 === 1 || values.system_role * 1 === 2) {

              } else {
                if (value.groupid) {
                  if (Array.isArray(value.groupid)) {
                    if (value.groupid.length === 0) {
                      if (!isnoGroup) {
                        this.$message.warning(`${grouptip[0]}${value.truename}${grouptip[1]}`)
                        isnoGroup = true
                      }
                    }
                  } else {
                    if (!isnoGroup) {
                      this.$message.warning(`${grouptip[0]}${value.truename}${grouptip[1]}`)
                      isnoGroup = true
                    }
                  }
                } else {
                  if (!isnoGroup) {
                    this.$message.warning(`${grouptip[0]}${value.truename}${grouptip[1]}`)
                    isnoGroup = true
                  }
                }
              }
              return true
            }
          })
        } else if (value.userid) {
          if (!isnoGroup) {
            this.$message.warning(`请为${value.truename}选择角色`)
            isnoGroup = true
          }
        }
      })
      return isnoGroup
    },
    getVoldMembers (array) {
      let tempv = []
      // const { dingtalkStructureStatus } = this
      array.map(value => {
        if (value.title) {
          this.$delete(value, 'title')
        }
        if (value.roleid) {
          tempv.push(value)
        }
      })
      return tempv
    },
    // 添加成员---取消操作
    handleCancel () {
      this.setAddMemberLoading(false)
      this.setAddMemberVisible(false)
      this.selectedMembers = []
    },
    searchdeep (arr, searchArr, keyword, parentName) {
      arr.forEach(item => {
        if (item.sys_userid && (item.truename.indexOf(keyword) > -1)) {
          item['label'] = parentName ? `${parentName}` : ''
          item['userid'] = item['sys_userid'] ? item.sys_userid : 0
          item['truename'] = item['sys_truename'] ? item['sys_truename'] : item['name']
          item['checkboxtypeLabel'] = 0
          searchArr.push(
            item
          )
        } else {
          item['label'] = parentName ? `${parentName}|${item.name}` : `${item.name}`
          if (item.children && item.children.length) {
            this.searchdeep(item.children, searchArr, keyword, item['label'])
          }
        }
      })
    }
  }
}
</script>
<style lang="scss">
.search-div {
  // .anticon-search {
  //   margin-right: 60px;
  // }
}
.add-memeber-dialog {
  .ant-modal-body {
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>

<style lang="scss" scoped>
.select-name-span {
  width: 60px;
  display: inline-block;
  margin-bottom: 8px;
  overflow: hidden;
  vertical-align: middle;
  margin-top: 8px;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  white-space: nowrap;
}
.main-member-parent {
  display: table;
  width: 100%;
  height: 200px;
  overflow: auto;
  .main-member-children {
    display: table-cell;

    &:first-child {
      border-right: solid 1px #ebebeb;
      width: 45%;
      padding-top: 24px;
      .select-normal-box {
         //padding-left: 10px;
        //border-top: 1px solid #ebebeb;
        // margin-top: 11px;
        // padding-top: 8px;
      }
      .search-no-result {
        padding: 16px;
        text-align: center;
        height: 295px;
        width: 320px;
      }
      .select-list-div {
        height: 423px;
        // width: 405px;
        overflow: auto;
        margin-right: 4px;
        margin-top: 16px;
      }
      /* .select-list-div::-webkit-scrollbar {
        width: 4px;
        height: 20px;
        border-radius: 2px;
      }
      .select-list-div::-webkit-scrollbar-thumb {
        border-radius: 2px;
        background-color: #ebebeb;
      }
      .select-list-div::-webkit-scrollbar-track {
        border-radius: 0;
        background: #fff;
      } */
    }
    &:last-child {
      padding: 0px 12px 0px 12px;
    }
    .select-title-div {
      height: 40px;
    }
    .remove-icon {
      margin-left: 12px;
      color: #c0c4cc;
      vertical-align: middle;
      cursor: pointer;
      width: 16px;
      height: 16px;
    }
  }
}
.second-seclect {
  width: 180px;
  margin-left: 12px;
}
.list-content-span {
  width: 360px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
  .checkbox {
    vertical-align: middle;
    // margin-top: -4px;
  }
  .text {
    max-width: 200px;
    display: inline-block;
    // overflow: hidden;
    vertical-align: middle;
    height: 24px;
    line-height: 24px;
    margin-top: -16px;
    // text-overflow: ellipsis;
    // -o-text-overflow: ellipsis;
    white-space: nowrap;
  }

  .tag-list-content {
    max-width: 220px;
    margin-left: 4px;
    text-align: left;
    vertical-align: middle;
    margin-top: -18px;
    display: inline-block;
    .tag {
      margin-left: 4px;
    }
  }
}
.selected-select {
  margin-left: 14px;
  width: 120px;
  margin-bottom: 16px;
}
.remain-member-list::v-deep{
  padding: 0px 12px 0px 12px;
  .a-list-item {
    cursor: pointer;
    height: 40px;
    line-height: 40px;
  }
  .ant-spin-container {
    width: 320px;
  }
}
.search-div {
  padding: 0px 32px 0px 12px;
}
.add-search-result::v-deep {
  color: #666;
  padding-left: 10px;
  // border-top: 1px solid #ebebeb;
  // margin-top: 11px;
  padding-top: 8px;
  .origin-list-ul {
    height: 431px;
    overflow-y: auto;
    .ant-tag {
      margin-left: 10px;
    }
  }
  ul {
    // max-height: 500px;
    // overflow-y: auto;
  }
  li {
    width: 320px;
    h2 {
      position: relative;
      height: 24px;
      line-height: 24px;
      padding-right: 20px;
      padding-top: 8px;;
      color: #666;
      .ant-checkbox-wrapper {
        position: absolute;
        right: 0;
      }
    }
    p{
      font-size: 12px;
      padding: 8px 0;
    }
  }
}
.tree-list-box::v-deep{
  //border-top: 1px solid #ebebeb;
  // margin-top: 11px;
  padding: 8px 5px 0 10px;
  margin-bottom: 9px;
  .tree-list {
    // padding: 0 12px 0 10px;
    padding-right: 8px;
    height: 422px;
    overflow-y: auto;
    .ant-tree  {
      width: 320px;
    }
     .ant-tree li{
      padding: 0;
    }
    .ant-tree-switcher-noop {
      display: none;
    }
    .uncheck-item {
      position: relative;
      .ant-checkbox-wrapper {
        position: absolute;
        right: 0;
      }
      .tag {
        margin-left: 10px;
      }
    }
    .checkbox-box-c{
      padding-right: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .ant-tree li span.ant-tree-switcher, .ant-tree li span.ant-tree-iconEle {
      width: 12px;
      color: #959595;
      height: 40px;
      line-height: 40px;
    }
    .ant-tree li .ant-tree-node-content-wrapper,li.ant-tree-treenode-disabled > span:not(.ant-tree-switcher), li.ant-tree-treenode-disabled > .ant-tree-node-content-wrapper, li.ant-tree-treenode-disabled > .ant-tree-node-content-wrapper span {
      color: #666;
    }
    .ant-tree li .ant-tree-node-content-wrapper {
      width: 100%;
      height: 40px;
      line-height: 40px;
      .ant-checkbox-wrapper {
        margin-right: 0;
      }
    }
    .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected,.ant-tree li:not(.ant-tree-treenode-disabled) .ant-tree-node-content-wrapper:hover{
      background: #F4F7F9;
    }
    .ant-tree li ul{
      padding-left: 8px;
    }
  }

}
</style>
